export function getDeadlineField(source, key, fallback) {
  const pascalKey = key.charAt(0).toUpperCase() + key.slice(1)
  return source?.[key] ?? source?.[pascalKey] ?? fallback
}

function hasCalculatedDeadline(deadline) {
  const dueDate = getDeadlineField(deadline, 'dueDate')
  const unit = getDeadlineField(deadline, 'deadlineUnit')
  return typeof dueDate === 'string' && !Number.isNaN(Date.parse(dueDate)) &&
    (unit === 'FIXED_DATE' || Number(getDeadlineField(deadline, 'deadlineAmount')) > 0) &&
    unit !== 'NO_DEADLINE' &&
    getDeadlineField(deadline, 'deadlineRuleCode') !== 'PRAZO_PROVISORIO_5_DIAS_UTEIS'
}

function hasCompleteCommandCalculation(result) {
  const actions = getDeadlineField(result, 'interpretedActions', [])
  const deadlines = getDeadlineField(result, 'resolvedDeadlines', [])
  const assessment = getDeadlineField(result, 'deadlineAssessment')

  // A date alone does not establish that a current command was identified.
  // Narrative matches, operational follow-ups and conditional appeal windows
  // must keep their own pending/conditional presentation.
  if (!actions.length || !deadlines.length || actions.some(action =>
    !getDeadlineField(action, 'actionCode') || getDeadlineField(action, 'commandSourceSection') !== 'COMMAND')) return false
  if (!deadlines.every(deadline => hasCalculatedDeadline(deadline) && actions.some(action =>
    getDeadlineField(action, 'actionCode') === getDeadlineField(deadline, 'actionCode')))) return false
  if (!actions.every(action => deadlines.some(deadline =>
    getDeadlineField(deadline, 'actionCode') === getDeadlineField(action, 'actionCode')))) return false

  if (!assessment) return true
  if (getDeadlineField(assessment, 'status') !== 'DATE_SUGGESTED' ||
    getDeadlineField(assessment, 'missingInformation', []).length > 0) return false
  return getDeadlineField(assessment, 'suggestions', []).every(suggestion =>
    !['OPERATIONAL_FALLBACK', 'CONDITIONAL_APPEAL_WINDOW'].includes(getDeadlineField(suggestion, 'basis')) &&
    hasCalculatedDeadline(getDeadlineField(suggestion, 'deadline')))
}

export function getDeadlineResultPresentation(result) {
  const rawStatus = getDeadlineField(result, 'status')
  const status = String(rawStatus ?? '').toLowerCase()
  const reviewDecision = getDeadlineField(result, 'reviewDecision')
  const humanReviewRequired = getDeadlineField(reviewDecision, 'requiresHumanReview') === true ||
    getDeadlineField(result, 'humanReviewRequired') === true ||
    status === 'humanreviewrequired' || status === '2'
  const calculatedWithReview = humanReviewRequired &&
    ['analyzed', 'humanreviewrequired', '1', '2'].includes(status) && hasCompleteCommandCalculation(result)

  if (status === 'error' || status === '4')
    return { label: 'Erro na análise', tone: 'is-danger', humanReviewRequired, calculatedWithReview: false }
  if (status === 'notimplemented' || status === '3')
    return { label: 'Análise indisponível', tone: 'is-warning', humanReviewRequired, calculatedWithReview: false }
  if (calculatedWithReview)
    return { label: 'Análise concluída com alerta', tone: 'is-success', humanReviewRequired, calculatedWithReview }
  if (humanReviewRequired)
    return { label: 'Revisão necessária', tone: 'is-warning', humanReviewRequired, calculatedWithReview }
  if (status === 'analyzed' || status === '1')
    return { label: 'Análise concluída', tone: 'is-success', humanReviewRequired, calculatedWithReview }
  return {
    label: rawStatus ? String(rawStatus).replace(/([a-z])([A-Z])/g, '$1 $2') : 'Não informado',
    tone: 'is-info', humanReviewRequired, calculatedWithReview,
  }
}
